import { Typography } from '@mui/material';
import styled from 'styled-components';

import { BaseColorKeys, SubjectColorKeys } from '../../theme';

const LoadingWrapper = styled.div`
    width: 100%;
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface TimesheetEntryProps {
  $color?: BaseColorKeys | SubjectColorKeys
}

const TimesheetEntry = styled.div<TimesheetEntryProps>`
    width: 100%;
    background-color: ${({ $color, theme }) => ($color ? theme.palette[$color].light : theme.palette.darkPrimary.light)};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    padding: ${({ theme }) => theme.spacing(1)};
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    justify-content: left;
    align-items: center;
    &:hover {
        background-color: ${({ $color, theme }) => ($color ? theme.palette[$color].main : theme.palette.darkPrimary.main)};
        cursor: pointer;
    }
`;

const EntryText = styled(Typography)`
    && {
        overflow: ellipsis;
    }
`;

export { LoadingWrapper, TimesheetEntry, EntryText };
